import React, {Component} from 'react';
import styles from "../../../InfoCliniche/InfoCliniche.module.css";
import RadioButton from "../../../../../../components/radiobutton/RadioButton";
import {withTranslation} from "react-i18next";
import Utils from "../../../../../../utils/Utils"

class SezioneNove extends Component {

    state = {
        sezioneNove: {
            positivoHIV: "",
            testHIV: "",
            corretto: []
        }
    }

    constructor(props) {
        super(props);
        this.riceviValoreRadioButton = this.riceviValoreRadioButton.bind(this);
        this.controllaDati = this.controllaDati.bind(this);
        this.createJsonBackend = this.createJsonBackend.bind(this)
        this.validate = this.validate.bind(this);
    }

    componentDidMount() {
        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.sezioneNove) {
            let sezioneNove = this.state.sezioneNove
            let propsSezione = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.schedaSpeciale.sezioneNove))
            sezioneNove.positivoHIV = propsSezione.positivoHIV ? propsSezione.positivoHIV : ""
            sezioneNove.testHIV = propsSezione.testHIV ? propsSezione.testHIV : ""
            this.setState({sezioneNove: sezioneNove});
        }
        this.controllaDati();
        this.props.setSezioneNove(this.state.sezioneNove)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.controllaDati();
        if (prevState !== this.state) {
            let res = this.createJsonBackend()
            this.props.setSezioneNove(this.state.sezioneNove, this.validate(), res)
        }
    }

    validate() {
        if (this.state.sezioneNove.testHIV !== "01" && this.state.sezioneNove.positivoHIV) return "Messages.ERR_01_02_0D_BB"

        return ""
    }

    createJsonBackend() {
        let dati = JSON.parse(JSON.stringify(this.state.sezioneNove))
        let sezioneBackend = Utils.removeEmptyValueFromObject(dati)
        return Utils.removeFieldFromObject(sezioneBackend, "corretto")
    }

    controllaDati() {

        let dati = this.state.sezioneNove
        dati.corretto = []

        if (dati.testHIV === "01" && dati.positivoHIV === "") dati.corretto[0] = "Campo \"Se si, è risultato positivo al test per l'HIV?\" mancante";


    }

    riceviValoreRadioButton(event, field) {
        let sezioneNove = this.state.sezioneNove
        sezioneNove[field] = event

        if (sezioneNove.testHIV !== "01") {
            sezioneNove.positivoHIV = ""
        }

        this.setState({sezioneNove: sezioneNove})
    }


    render() {

        const {t} = this.props;

        const sezioneNove = (
            <div style={{marginTop: "10px"}}>
                <div>
                    <h6>Sezione 9</h6>
                    <hr className={styles.hr}/>
                </div>
                <div className={"container"}>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6"><p className={styles.labelHeader} style={{marginTop: "10px"}}>
                            <b>{t("SchedaEpatite.sezione9.domandaUno")}</b></p></div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"testHIVSi"}
                                             name={"testHIV"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "testHIV")}
                                             checked={this.state.sezioneNove.testHIV === "01"}
                                >
                                </RadioButton>
                                <RadioButton id={"testHIVNo"}
                                             name={"testHIV"} label={t("SchedaEpatite.risposteTipoUno.no")}
                                             value={"02"}
                                             onClick={() => this.riceviValoreRadioButton("02", "testHIV")}
                                             checked={this.state.sezioneNove.testHIV === "02"}
                                />
                                <RadioButton id={"testHIVNonSo"}
                                             name={"testHIV"} label={t("SchedaEpatite.sezione8.nonRispondere")}
                                             value={"03"}
                                             onClick={() => this.riceviValoreRadioButton("03", "testHIV")}
                                             checked={this.state.sezioneNove.testHIV === "03"}
                                />
                            </div>
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione9.domandaDue")}</b>
                                {(this.state.sezioneNove.testHIV === "01") ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"positivoHIVSi"}
                                             name={"positivoHIV"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             disabled={this.state.sezioneNove.testHIV !== "01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "positivoHIV")}
                                             checked={this.state.sezioneNove.positivoHIV === "01"}
                                >
                                </RadioButton>
                                <RadioButton id={"positivoHIVNo"}
                                             name={"positivoHIV"} label={t("SchedaEpatite.risposteTipoUno.no")}
                                             value={"02"}
                                             disabled={this.state.sezioneNove.testHIV !== "01"}
                                             onClick={() => this.riceviValoreRadioButton("02", "positivoHIV")}
                                             checked={this.state.sezioneNove.positivoHIV === "02"}
                                />
                                <RadioButton id={"positivoNonSo"}
                                             name={"positivoHIV"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
                                             value={"03"}
                                             disabled={this.state.sezioneNove.testHIV !== "01"}
                                             onClick={() => this.riceviValoreRadioButton("03", "positivoHIV")}
                                             checked={this.state.sezioneNove.positivoHIV === "03"}
                                />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );


        return <div>

            {sezioneNove}
        </div>
    }


}

export default withTranslation('common')(SezioneNove)
